import { AUTH_SERVICE_URL_TOKEN } from "../../constants";

export function provideAuthServiceUrl(authServiceUrl: string) {
  return {
    provide: AUTH_SERVICE_URL_TOKEN,
    useValue: authServiceUrl,
  };
}
